import React from 'react';
import {RadioButton as VWRadioButton} from '@volkswagen-onehub/components-core';
import {RadioButtonProps} from '@volkswagen-onehub/whitelabel-e-mobility-commons';

export function RadioButton(props: RadioButtonProps): JSX.Element {
  return <VWRadioButton {...props} data-testid={props.testId} />;
}
